module.exports = __webpack_public_path__ + "img/mu.67c8f362.svg";